/**
 * Pure helpers for quiz branching and per-question validation.
 * No React, no I/O — kept separate from QuizScreen so both are unit-testable
 * without rendering.
 */

/** Which questions currently apply, given the answers so far (recompute on every answers change). */
export function getApplicableQuestions(questions, answers) {
  return questions.filter((q) => !(q.skipIf && q.skipIf(answers)));
}

/** Whether `question` has a valid answer in `value`. Optional (required:false) questions are always valid. */
export function isQuestionAnswered(question, value) {
  if (question.required === false) return true;
  if (question.type === 'single') {
    return Boolean(value && typeof value.value === 'string' && value.value.length > 0);
  }
  if (question.type === 'multi') {
    return Boolean(value && Array.isArray(value.values) && value.values.length > 0);
  }
  return true;
}
